export class AdminModel{

    public username: string;
    constructor() {
    }
}
